import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface AppChatState {
	isLoading: boolean;
	userId: string;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ui-app-chat' })
export class AppChatStore extends Store<AppChatState> {
	constructor() {
		super({ isLoading: true });
	}
}
